/**
 * Flip-Through Work JavaScript
 *
 * This file defines behaviors of
 * the Flip-Through Work block.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

document.querySelectorAll('.case-flip')?.forEach((flip) => {
	gsap.registerPlugin(ScrollTrigger);

	const tl = gsap.timeline();
	const items = [...flip.querySelectorAll('.case-flip__item')];

	items.forEach((el, i) => {
		tl.to(el, {
			x: '100%',
			y: '-1%',
			rotationY: 0.5,
			ease: 'power2.in',
			boxShadow: '30px 10px 35px 20px rgba(0, 0, 0, 0.25)',
		})
			.to(el, {
				translateZ: `${(items.length - i) * 1}`,
				x: '105%',
				rotationY: -0.5,
				ease: 'power2.out',
				boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.75)',
			})
			.to(el, {
				x: `${i}%`,
				y: `${i}%`,
				rotationY: 0,
				boxShadow: '0px 2px 7px 0px rgba(0, 0, 0, 0.5)',
				ease: 'power2.inOut',
			})
			.addLabel(`case-${i}`);
	});

	tl.fromTo(
		items,
		{ rotate: 0.5 },
		{ rotate: -0.5, duration: items.length * 2 },
		`-=${items.length * 1.5}`
	);

	ScrollTrigger.create({
		trigger: flip,
		start: '0% 0%',
		end: '100% -100%',
		animation: tl,
		// scrub: 1,
		scrub: 0,
		pin: true,
		snap: {
			snapTo: 'labels',
			duration: { min: 0.2, max: 1 },
			delay: 0.1,
			ease: 'power1.inOut',
		},
		// /* DEBUG */ markers: true,
	});
});
